// import { environment } from '../../../../environments/environment';
import type Basemap from '@arcgis/core/Basemap';

import { TVBasemap } from './basemap';
// import MapImageLayer from '@arcgis/core/layers/MapImageLayer';

export const BaseLayer = (): Basemap => {
  const _basemap = TVBasemap;

  // // Add the lots to the layer.
  // const lotLayer = new MapImageLayer({
  //   url: `${environment.mapServer}/2509`,
  //   title: 'Lots',
  // });

  // basemap.referenceLayers.add(lotLayer);

  return _basemap;
};
